import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import css from '../assets/css.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';


import anime from '../assets/anime.png'
import mysql from '../assets/mysql.png'
import mongoDb from '../assets/mongoDb.png'


export default {
    email,
    mobile,
    css,
    git,
    html,
    javascript,
    node,
    react,
    redux,
    sass,
    profile,
    circle,
    logo,
    anime,
    mysql,
    mongoDb,

};